import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';

/*
  Generated class for the AuthentificationService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.

  AuthentificationService gère tout ce qui a en rapport avec les le login, et l'utilisateur
*/
@Injectable()
export class AuthentificationService {
    
    private isLoggedIn : boolean; //True si l'utilisateur est connecté
    private userId: string;//Identifiant de firebase pour l'utilisateur
    private userName: string; //Nom de l'utilisateur, on a accès à cette information si l'utilisateur se logue avec autre chose que e-mail
    private email: string; //Email de l'utilisateur
    private photoURL: string; //Url de la photo de l'utilisateur, on a accès à cette information si l'utilisateur se logue avec autre chose que e-mail

    //Constructeur de l'authentification-service
    constructor(public af: AngularFire){
        console.log("Hello AuthentificationService");
    }
    //Setter pour la valeur "isLoggedIn"
    setLogged(val : boolean)
    {
        this.isLoggedIn=val;
    }
    //getter pour isLoggedIn
    getLogged()
    {
        return this.isLoggedIn;
    }
    //setter pour l'id de l'utilisateur
    setUserId(val)
    {
        console.log("username Set");
        this.userId=val;
    }
    //retourne l'id de l'utilisateur
    getUserId()
    {
        return this.userId;
    }
    //setteur pour le nom d'utilisateur
    setUserName(val)
    {
        this.userName=val;
    }
    //retourne le nom de l'utilisateur logué
    getUserName()
    {
        return this.userName;
    }
    //setteur pour l'url de la photo de l'utilisateur
    setPhotoUrl(val)
    {
        this.photoURL=val;
    }
    //retourne la photo de l'utilisateur logué
    getPhotoUrl()
    {
        return this.photoURL;
    }
    //setteur pour l'email
    setEmail(val)
    {
        this.email=val;
    }
    //retourne l'adresse e-mail de l'utilisateur logué
    getEmail()
    {
        return this.email;
    }
    //retourne un identifiant (soit email soit nom d'utilisateur)
    getIdentifier()
    {
        if(this.userName==undefined)
        {
            return this.email;
        }
        else
        {
            return this.userName;
        }
    }
}


// WEBPACK FOOTER //
// ./src/providers/authentification-service.ts